var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activeIndex == 'platform')?_c('div',[_c('div',{staticClass:"main"},[_c('menuBox'),_c('indexState'),_c('indexChat',{attrs:{"chatsData":_vm.chatsData},on:{"changType":_vm.changType,"changTime":_vm.changTime}})],1)]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }